import {DashboardPeriodData} from 'components/v2/app/dashboard/models';

export const parseFinancial = (number: number) =>
  Number(parseFloat(String(number)).toFixed(2)).toLocaleString();

export const getMostCurrentDataDashboardStat = (
  data?: Record<string, DashboardPeriodData>,
) => {
  if (data) {
    const mostRecentKey = Object.keys(data).reduce(
      (mostRecent, currentDate) => {
        const createdAt = data[currentDate].created_at;
        const mostRecentAt = data[mostRecent].created_at;
        return new Date(createdAt) > new Date(mostRecentAt)
          ? currentDate
          : mostRecent;
      },
    );
    return data[mostRecentKey];
  } else {
    return null;
  }
};
